import React, { forwardRef } from 'react';
import { capitalizeFirstLetter } from 'common/helpers/string';
import styles from './PrintTransactionHistory.module.scss';
import classNames from 'classnames/bind';

type Props = {
  Model?: any;
  PageData?: any;
  columns?: any[];
  transactions?: any[];
};

const PrintTransactionHistory = forwardRef(
  ({ Model, PageData, columns, transactions }: Props, ref: any) => {
    return (
      <div className={styles.wrapper} ref={ref}>
        <div id="container">
          <header>
            <img
              className={styles.logo}
              src={`${process.env.PUBLIC_URL}/hoist_logo_color.svg`}
              width="272"
            />
          </header>
          <h2>{PageData?.TransactionHistoryTabHeader}</h2>
          <div className={styles.debtBalance}>
            {PageData?.DebtBalanceLabel}:
            <span>{Model?.FormattedCurrencyDebtBalance}</span>
          </div>
          <div className={styles.row}>
            {PageData?.TransactionHistoryAccountLegacyIdLabel}:{' '}
            {Model?.AccountLegacyId}
          </div>
          <div className={styles.filters}></div>
          <table>
            <thead>
              <tr>
                {(columns || []).map(
                  (column: any, index: number) =>
                    column.isVisible && <th key={index}>{column.value}</th>,
                )}
              </tr>
            </thead>
            <tbody>
              {(transactions || []).map((transaction: any, index: number) => {
                return (
                  <tr key={index}>
                    {(columns || []).map((column: any, index: any) => {
                      if (column.isVisible) {
                        return (
                          <td
                            key={index}
                            className={classNames(
                              (column.key === 'amount' ||
                                column.key === 'balance') && styles.amount,
                            )}
                          >
                            <span
                              dangerouslySetInnerHTML={{
                                __html:
                                  transaction[
                                    capitalizeFirstLetter(column.key)
                                  ],
                              }}
                            />
                          </td>
                        );
                      }
                      return null;
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  },
);

export default PrintTransactionHistory;
